// Branded logo mark — official Advance Networks LLC monogram.
// PNG is served from /public/advance-networks-logo.png with a transparent
// background so it sits cleanly on light AND dark surfaces without a colored
// frame. Pass `size` for square dimensions (px). Aspect ratio is preserved
// via object-contain — never stretched or cropped.
export function Logo({ size = 40, className = "", "data-testid": testId }) {
    return (
        <img
            src="/advance-networks-logo.png"
            alt="Advance Networks LLC"
            width={size}
            height={size}
            className={`object-contain shrink-0 select-none ${className}`}
            style={{ width: size, height: size }}
            draggable={false}
            data-testid={testId}
        />
    );
}
